var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53848 28.209C9.76217 29.9577 12.567 31.0008 15.6154 31.0008C18.6638 31.0008 21.4686 29.9577 23.6923 28.209",
    stroke: "#FF9D2E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7692 5.42188C6.42402 7.06427 2.53841 12.0404 2.53841 17.924C2.53841 19.4047 2.78448 20.8278 3.23794 22.1548",
    stroke: "#FF9D2E",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4614 5.42188C24.8066 7.06427 28.6922 12.0404 28.6922 17.924C28.6922 19.4047 28.4461 20.8278 27.9926 22.1548",
    stroke: "#FF9D2E",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2308 25.6147C30.2308 26.6467 29.8243 27.5837 29.1629 28.2745C28.4627 29.0056 27.4769 29.4609 26.3846 29.4609C24.2605 29.4609 22.5385 27.7389 22.5385 25.6147C22.5385 24.0685 23.4509 22.7354 24.7667 22.1244C25.2585 21.896 25.8067 21.7686 26.3846 21.7686C28.5088 21.7686 30.2308 23.4906 30.2308 25.6147Z",
    fill: "white",
    stroke: "#FF9D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69231 25.6147C8.69231 26.6467 8.28585 27.5837 7.62438 28.2745C6.92423 29.0056 5.93838 29.4609 4.84615 29.4609C2.72198 29.4609 1 27.7389 1 25.6147C1 24.0685 1.91242 22.7354 3.22821 22.1244C3.72003 21.896 4.26821 21.7686 4.84615 21.7686C6.97031 21.7686 8.69231 23.4906 8.69231 25.6147Z",
    fill: "white",
    stroke: "#FF9D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4617 4.84615C19.4617 5.87815 19.0552 6.81515 18.3937 7.50592C17.6936 8.23708 16.7077 8.69231 15.6155 8.69231C13.4914 8.69231 11.7694 6.97031 11.7694 4.84615C11.7694 3.29993 12.6817 1.96682 13.9976 1.35585C14.4894 1.12748 15.0376 1 15.6155 1C17.7397 1 19.4617 2.72198 19.4617 4.84615Z",
    fill: "white",
    stroke: "#FF9D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.2840a6d2475da2ae0240e0a0e5e63db7.svg";
export { ForwardRef as ReactComponent };